export const playground = { holes: 18 }



// WEBPACK FOOTER //
// ./src/constants/playgrounds.ts